export const timeline = [
  {
    date: "2026.06.28",
    title: "后台采访的两秒沉默",
    text: "采访间所有人停下手里的动作，收音杆多举了两秒才放下来。这段后来被剪成各种版本传播。",
    tag: "名场面",
  },
  {
    date: "2026.07.06",
    title: "前三名合影的八秒调度",
    text: "走位、让位、笑容收回，慢放解析的播放量超过了正片。围观者开始第一次认真讨论表情管理。",
    tag: "表情管理",
  },
  {
    date: "2026.07.18",
    title: "才艺环节多出来的三十秒",
    text: "评委把笔放了回去，重新靠回椅背。即兴加戏成了那晚讨论度最高的话题。",
    tag: "即兴",
  },
  {
    date: "2026.07.30",
    title: "放错的 BGM 与接管节拍的选手",
    text: "音响切错曲目，选手用两秒决定换一套跳法。事故只影响一段，却留下一个经典救场。",
    tag: "救场",
  },
  {
    date: "2026.08.14",
    title: "崴脚之后的那个劈叉",
    text: "掌声比原定编排还响。形体老师把它当作临场反应案例，转发从娱乐区一路走到了教学区。",
    tag: "临场反应",
  },
  {
    date: "2026.08.18",
    title: "冠军揭晓前的五秒空白",
    text: "光束打错了人，掌声停在了半空。最后是靠选手之间的一个拥抱把场子兜了回来。",
    tag: "翻车复盘",
  },
];